import useApiClient from './api-client'
import type { NicedayFilterFilterRes } from '@/types/api'
import type { GetFiltersReqParams } from '@/types/filters'

export const getFilter = async (params: GetFiltersReqParams) => {
  const api = useApiClient<NicedayFilterFilterRes>()
  const result = await api(`/filters`, { query: params })

  return result
}
